import { makeAutoObservable, runInAction } from 'mobx'
import { DatabusNotification } from 'models'
import RootModel from 'models/RootModel'

export class NotificationModel {
  parent: RootModel
  notification: DatabusNotification | null = null
  constructor(parent: RootModel) {
    makeAutoObservable(this)
    this.parent = parent
  }
  set_notification(note?: DatabusNotification | null) {
    runInAction(() => {
      this.notification = note ?? null
    })
  }
}

export default NotificationModel